/**
 * Удаление папки «Наших фото» (№438, спека 2026-10-29-dress-delete-design.md): сводка
 * `GET /api/dresses/{id}/delete` и текст окна подтверждения. Ручки — в `lib/photos.ts`.
 */

/** Что уйдёт и что мешает: `blockers` — причины по-русски от сервера, пусто — можно удалять. */
export type DressDeletePreview = {
  id: number;
  photos: number;
  /** Фото из чата «Head Все»: после удаления выгрузка их больше не скачает. */
  chat_photos: number;
  /** Генерации платья — останутся в «Результатах» без платья. */
  generations: number;
  crm_model_id: number | null;
  blockers: string[];
};

function plural(n: number, one: string, few: string, many: string): string {
  const d = n % 10;
  const dd = n % 100;
  if (d === 1 && dd !== 11) return one;
  if (d >= 2 && d <= 4 && (dd < 10 || dd >= 20)) return few;
  return many;
}

/** Строки окна: что уйдёт, что останется, как вернуть. */
export function deleteSummary(p: DressDeletePreview): string[] {
  const what = p.crm_model_id !== null ? `${p.photos} фото и привязка к CRM` : `${p.photos} фото`;
  const lines = [`Из «Наших фото» уйдут ${what}; файлы останутся в хранилище.`];
  if (p.crm_model_id !== null)
    lines.push("Модель можно импортировать заново — «Импорт из CRM» на странице «Наши фото».");
  if (p.chat_photos > 0)
    lines.push(
      `${p.chat_photos} ${plural(p.chat_photos, "фото пришло", "фото пришли", "фото пришли")} из чата «Head Все» — ` +
        "их не вернуть: выгрузка из чата их больше не скачает.",
    );
  if (p.generations > 0)
    lines.push(
      `${p.generations} ${plural(p.generations, "генерация останется", "генерации останутся", "генераций останутся")} ` +
        "в «Результатах», но без платья.",
    );
  return lines;
}
